import {Animation} from "./classes/Animation";
import {Datepicker} from "./classes/Datepicker";
import {JqueryValidator} from "./classes/JqueryValidator";
import {CloudflareTurnstille} from "./classes/CloudflareTurnstille";
import {FormValidation} from "./classes/FormValidation";
import {Validator} from "./classes/Validator";
import {GA} from "./classes/GA";
const br2nl = require('@derhuerst/br2nl')


jQuery(function ($) {
    // Shortcodes AJAX request

    /**
     * Update EN counter shortcodes with AJAX request (because of cache)
     */
    function updateEnCounterShortcodes() {
        var enCounters = [];

        $('.js-en-counter').each(function(index, element) {
            var $element = $(element);

            enCounters.push({
                'service': $element.attr('data-service'),
                'profile_name': $element.attr('data-profile_name'),
                'campaign_id': $element.attr('data-campaign_id'),
                'post_id': $element.attr('data-post-id'),
                'id': $element.attr('data-id')
            });
        });

        if(enCounters.length > 0) {
            jQuery.ajax({
                type: "POST",
                url: ajaxUrl,
                data: {
                    'action': 'enCounterUpdate',
                    'enCounters': enCounters
                },
                success: function (response) {
                    const data = JSON.parse(response).data;

                    for(const id in data) {
                        const html = data[id];
                        //
                        var $counter = $('.js-en-counter[data-id="'+id+'"]');
                        $counter.html(html);
                        // Animate count
                        Animation.animateElementNumber($counter.find('.js-animate-count'));
                    }
                },
                error: function(errorThrown){
                    console.log(errorThrown);
                }
            });
        }
    }

    /**
     * Update site petition and petition component
     */
    function updatePetitionProgressBar() {
        var petitions = [];

        $('.js-progress-petition').each(function(index, element) {
            var $element = $(element);

            petitions.push({
                id: $element.attr('data-post-id'),
                component_id: $element.attr('data-component-id')
            });
        });

        if(petitions.length > 0) {
            jQuery.ajax({
                type: "POST",
                url: ajaxUrl,
                data: {
                    'action': 'petitionProgressBarUpdate',
                    'petitions': petitions
                },
                success: function (response) {
                    const data = JSON.parse(response).data;
                    //
                    for(const id in data) {
                        var rowData = data[id];
                        var postId = rowData['id'];
                        var componentId = rowData['component_id'];
                        var line = rowData['percent'];
                        var added = rowData['added'];

                        //
                        if(componentId) {
                            // component
                            var $element = $('.js-progress-petition.is-component[data-component-id="'+ componentId +'"]');
                        } else {
                            // post form
                            var $element = $('.js-progress-petition.is-post[data-post-id="'+ postId +'"]');
                        }
                        //
                        $element.find('.js-progress-line').attr('data-line', line);
                        $element.find('.js-progress-added').attr('data-count', added);
                        // $element.find('.js-progress-goal').attr('data-count', rowData['goal']);
                        //
                        Animation.animatePetitionProgressBar($element);
                    }
                },
                error: function(errorThrown){
                    console.log(errorThrown);
                }
            });
        }
    }

    /**
     * Update donation progress bar (page and component)
     */
    function updateDonationProgressBar() {
        var petitions = [];

        $('.js-donation-progress-bar').each(function(index, element) {
            var $element = $(element);

            petitions.push({
                id: $element.attr('data-post-id'),
                component_id: $element.attr('data-component-id')
            });
        });

        if(petitions.length > 0) {
            jQuery.ajax({
                type: "POST",
                url: ajaxUrl,
                data: {
                    'action': 'donationProgressBarUpdate',
                    'petitions': petitions
                },
                success: function (response) {
                    const data = JSON.parse(response).data;
                    //
                    for(const id in data) {
                        var rowData = data[id];
                        var postId = rowData['id'];
                        var componentId = rowData['component_id'];
                        var timeUntilHide = rowData['time_until_hide'];

                        //
                        if(componentId) {
                            // component
                            var $element = $('.js-donation-progress-bar.is-component[data-component-id="'+ componentId +'"]');
                        } else {
                            // post form
                            var $element = $('.js-donation-progress-bar.is-post[data-post-id="'+ postId +'"]');
                        }

                        //
                        $element.find('.js-donation-days-to-end-text').text(rowData['days_to_end_text']);
                        $element.find('.js-donation-donor-count').attr('data-count', rowData['count_donors']);
                        $element.find('.js-donation-target-amount').attr('data-count', rowData['target_amount']);
                        $element.find('.js-donation-target-currency').text(rowData['target_amount_currency']);
                        $element.find('.js-donation-collected-amount').attr('data-count', rowData['collected_amount']);
                        $element.find('.js-donation-days-to-end').attr('data-count', rowData['days_to_end']);
                        if(!timeUntilHide) {
                            $element.find('.js-donation-time-until-hide').show();
                            $element.find('.js-donation-time-until-hide-count');
                        }
                        $element.find('.js-progress-line').attr('data-line', rowData['progress_bar_percent']);

                        //
                        Animation.animateDonationProgressBar($element);
                    }
                },
                error: function(errorThrown){
                    console.log(errorThrown);
                }
            });
        }
    }


    /**
     *
     */
    function updateSocialProgressEmailBar() {
        var bars = [];

        $('.js-socials-email-tab').each(function(index, element) {
            var $element = $(element);

            bars.push({
                id: $element.attr('data-post-id'),
                component_id: $element.attr('data-component-id')
            });
        });

        if(bars.length > 0) {
            jQuery.ajax({
                type: "POST",
                url: ajaxUrl,
                data: {
                    'action': 'socialProgressEmailBarUpdate',
                    'bars': bars
                },
                success: function (response) {
                    const data = JSON.parse(response).data;
                    //
                    for(const id in data) {
                        var rowData = data[id];
                        var postId = rowData['id'];
                        var componentId = rowData['component_id'];

                        //
                        var $element = $('.js-socials-email-tab[data-component-id="'+ componentId +'"]');
                        var count = rowData['progress_count'];
                        var goal = rowData['progress_goal'];
                        var percent = rowData['progress_bar_percent'];

                        //
                        $element.find('.js-progress-bar-added').attr('data-count', count);
                        // $element.find('.js-progress-bar-goal').attr('data-count', goal);
                        $element.find('.js-progress-line').attr('data-line', percent);
                        //
                        Animation.animateSocialProgressEmailBar($element);
                    }
                },
                error: function(errorThrown){
                    console.log(errorThrown);
                }
            });
        }
    }


    updateSocialProgressEmailBar();
    updateEnCounterShortcodes();
    updatePetitionProgressBar();
    updateDonationProgressBar();

    // ----------------------------------------------------------------------------------------

    // Form
    JqueryValidator.define();

    // Form submit button loading
    $(document).on('click', 'button[type="submit"]', function (e) {
        var $form = $(this).closest('form');

        if(!$form.valid()) {
            return;
        }

        //
        if ($(this).hasClass('btn-primary')) {
            //
            $(this)
                .addClass('js-loading');
        } else {
            $(this).closest('.btn-primary')
                .addClass('js-loading');
        }
    });

    // Form submit
    $(document).on('submit', 'form.ajax', async function (e) {
        e.preventDefault();

        if (!$(this).valid()) {
            return;
        }

        var form = $(this);
        var submit = $('button[type="submit"], input[type="submit"]', form);

        // GTM LOGIKA PRO MOTIVATOR
        if (form.hasClass('socials-form')) {
            const email = form.find('input[name="email"]').val();
            let hashedEmail = null;

            if (email) {
                hashedEmail = await GA.sha256(email);
            }

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'engagementActivity',
                'eventCategory': 'engagement',
                'eventAction': 'Email',
                'gp_user_id': hashedEmail
            });
        }

        if (submit.hasClass('btn-primary')) {
            submit.addClass('js-loading').attr('disabled', 'disabled');
        } else {
            submit.closest('.btn-primary').addClass('js-loading').attr('disabled', 'disabled');
        }

        var data = new FormData(form[0]);
        form.find('.form-message').remove();

        $.ajax({
            type: 'POST',
            url: ajaxUrl,
            dataType: 'json',
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            success: function (response) {
                var content = form.find('.form-group-actions');
                $('<p class="form-message form-message--success">Formulář byl úspěšně odeslán.</p>').prependTo($(form).closest('.container').find('form'));
                form.find('input[name="first_name"], input[name="last_name"], input[name="email"]').val('');

                if (form.hasClass('socials-form')) {
                    $('.tabs-nav ul li a.active').removeClass('active');
                    $('.tabs-item').removeClass('tabs-item--active');
                    var $thankYouTab = $('.tabs-item[data-step="thank-you"]');
                    if ($thankYouTab.length > 0) {
                        $thankYouTab.addClass('tabs-item--active');
                    }
                    var target = $('#odesli');
                    $('html, body').animate({
                        scrollTop: target.offset().top - (target.offset().top > 74 ? 74 : 0)
                    }, 1000, function () {});
                }

                setTimeout(function () {
                    $('.form-message').remove();
                }, 5000);
            },
            error: function (response) {},
            complete: function (response) {
                if (submit.hasClass('btn-primary')) {
                    submit.removeClass('js-loading').removeAttr('disabled');
                } else {
                    submit.closest('.btn-primary').removeClass('js-loading').removeAttr('disabled');
                }
            }
        });
    });


    // Form ajax with snippets
    $(document).on('submit', 'form.js-ajax', function (e) {
        e.preventDefault();
        const form = $(this);
        const submit = $('button[type="submit"], input[type="submit"]', form);
        const data = new FormData(form[0]);

        if (submit.hasClass('btn-primary')) {
            submit
                .addClass('js-loading')
                .attr('disabled', 'disabled');
        } else {
            submit.closest('.btn-primary')
                .addClass('js-loading')
                .attr('disabled', 'disabled');
        }

        if (!form.valid()) {
            return false;
        }

        $.ajax({
            type: 'POST',
            url: ajaxUrl,
            dataType: 'json',
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            success: function (response) {
                const data = response.data;
                const snippets = data.snippets;

                // Redraw snippets
                for (const snippet in snippets) {
                    const content = snippets[snippet];
                    // Redraw snippet
                    $(snippet).html(content);
                }
            },
            error: function (response) {
            },
            complete: function (response) {
                if (submit.hasClass('btn-primary')) {
                    submit
                        .removeClass('js-loading')
                        .removeAttr('disabled');
                } else {
                    submit.closest('.btn-primary')
                        .removeClass('js-loading')
                        .removeAttr('disabled');
                }
            }
        });
    });

    // --------------------------------- Bully (Šikanatoor 2.0) ------------------------------------------------------

    function bully_set_current_step() {
        const currentStep = get_bully_current_step();
        const name = $('.js-bully-change-step[data-step="'+ currentStep +'"]').find('.bully-navigation__text').text();

        $('.js-bully-navigation-current-step').text(name);
    }

    /**
     * Show current stop
     */
    function bully_show_current_step() {
        const currentStep = get_bully_current_step();
        change_step(currentStep, null, false);
    }

    /**
     * @returns {string}
     */
    function get_bully_current_step() {
        const link = $('.bully-navigation__list-item.is-current .bully-navigation__link');

        return link.attr('data-step');
    }

    /**
     * @param {string} step
     * @return {bool}
     */
    function bully_is_last_step(step) {

        if ($('.bully-navigation__list-item').length > 0) {
            const lastStepOrder = $('.bully-navigation__list-item').length - 1;
            // Last step is thank you, but we want last step before thank you step
            const lastStep = $($('.bully-navigation__list-item').get(lastStepOrder - 1));
            const stepId = lastStep.find('.bully-navigation__link').attr('data-step');

            if (stepId == step) {
                return true;
            } else {
                return false;
            }
        } else {
            // There is only one step or 0 step
            return true;
        }

    }

    /**
     * @returns {string}
     */
    function get_bully_next_step() {
        let id = '';

        $('.bully-navigation__list-item').each(function (index) {

            if ($(this).hasClass('is-current')) {
                let nextStep = $('.bully-navigation__list-item').get(index + 1);
                nextStep = $(nextStep);

                id = nextStep.find('.bully-navigation__link').attr('data-step');
            }
        })

        return id;
    }

    /**
     * @returns {string}
     */
    function get_bully_previous_step() {
        let id = '';

        $('.bully-navigation__list-item').each(function (index) {

            if ($(this).hasClass('is-current')) {
                let nextStep = $('.bully-navigation__list-item').get(index - 1);
                nextStep = $(nextStep);

                id = nextStep.find('.bully-navigation__link').attr('data-step');
            }
        })

        return id;
    }

    /**
     * Change bully step
     *
     * @param {string} step
     * @param {string|null} lastStep
     * @param {boolean} notScroll
     */
    function change_step(nextStep, lastStep, scroll = true) {
        const link = $('.bully-navigation__link[data-step="' + nextStep + '"]');
        const section = $('#' + nextStep);
        let beforeCurrent = true;

        // Update navigation
        $('.bully-navigation__list-item').removeClass('is-current');
        link.closest('.bully-navigation__list-item').addClass('is-current');
        link.closest('.bully-navigation__list-item').addClass('is-visited');

        // Remove all nextSteps is-past
        $('.bully-navigation__list-item').removeClass('is-past');

        // add is-past to all nextSteps before current nextStep
        $('.bully-navigation__list-item').each(function (index) {

            if ($(this).hasClass('is-current')) {
                beforeCurrent = false;
            }

            if (beforeCurrent) {
                $(this).addClass('is-past');
            }
        });

        // Hide all sections
        $('.js-bully-step-section').hide();
        // Show current section
        section.show();

        // Same heights
        bully_boxes_same_heights();

        // Scroll to section
        if(scroll) {
            $('html, body').animate({
                scrollTop: $('#bully').offset().top - ($('.js-header-navbar').height() + 20)
            }, 500);
        }

        // Maybe show popup
        if(lastStep) {
            bully_maybe_show_completed_popup_modal(lastStep);
        }

        // Set step name
        bully_set_current_step();
    }

    function bully_email_form_validation() {
        $('#bully-email-form').validate({
            errorClass: 'invalid',
            rules: {
                first_name: {
                    required: true
                },
                last_name: {
                    required: true
                },
                email: {
                    required: true,
                    email: true
                },
                date_of_birth: {
                    required: true,
                    birthdate: true,
                    birthdate_age_restriction: true
                },
                phone_number: {
                    required: true,
                    // phone_number: true,
                },
                subject: {
                    required: true
                }
            },
            messages: {
                first_name: {
                    required: "Povinné pole"
                },
                last_name: {
                    required: "Povinné pole"
                },
                email: {
                    required: "Povinné pole",
                    email: "Neplatný formát"
                },
                date_of_birth: {
                    required: "Povinné pole",
                    birthdate: "Datum není valídni",
                    birthdate_age_restriction: "Musíte mít nejméně 13 let"
                },
                phone_number: {
                    required: "Povinné pole",
                    phone_number: "Neplatný formát"
                },
                text: {
                    required: "Povinné pole",
                },
                subject: {
                    required: "Povinné pole",
                }
            },
            submitHandler: function (form) {
                var $form = $(form);

                // Validate CF turnstille
                if(!CloudflareTurnstille.validate($form)) {
                    CloudflareTurnstille.handleInvalidForm($form);
                    //
                    return;
                }

                // Validate if user has checked agreement
                if(!FormValidation.customerAggreementValid($form)) {
                    return;
                }

                // Submit form
                form.submit();
            },
        });
    }

    /* ------------------------------------------------------------------------------------------------------------- */
    /* ----------------------------------------------  Bully   ----------------------------------------------------- */
    /* ------------------------------------------------------------------------------------------------------------- */


    /**
     * Bully model data
     * @type {{}}
     */
    const bully_model = {
        /**
         * Store progress bar points. Store completed steps
         */
        progress_bar_completed_steps: {},
        /**
         * Store which steps had showed their popup modal
         */
        popup_showed_steps: {
        }
    }
    /**
     * Check if bully step is completed
     *
     * @param {string} step
     * @return bool
     */
    function bully_is_step_completed(step) {
        if (bully_model.progress_bar_completed_steps.hasOwnProperty(step) !== false) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * @param {string} step
     */
    function bully_set_step_as_completed(step) {
        if (!bully_is_step_completed(step)) {
            bully_model.progress_bar_completed_steps[step] = true;
        }
    }

    /**
     * Show step modal after completing step if it has not been showed yet
     * @param {string} step
     */
    function bully_maybe_show_completed_popup_modal(step) {
        const modalId = '#' + step + '-modal'

        // Check if step has rendered modal
        if($(modalId).length > 0) {
            // Has been popup showed yet?
            if (bully_is_step_completed(step) && bully_model.popup_showed_steps.hasOwnProperty(step) === false) {
                // Show
                $.fancybox.open({
                    src: modalId
                });
                // Add step to model data
                bully_model.popup_showed_steps[step] = true;
            }
        }
    }

    /**
     * Filter subjects by selected filter values form
     *
     * @param showResults
     */
    function bully_filter_form(showResults = false) {
        const submit = $('.js-bully-filter-btn');
        const form = $('#bully-filter-form');
        const data = new FormData(form[0]);
        data.set('show_results', showResults);

        // Show animation
        $('.js-bully-loading').show();

        $.ajax({
            type: 'POST',
            url: ajaxUrl,
            dataType: 'json',
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            success: function (response) {
                const data = response.data;
                const snippets = data.snippets;

                // Redraw snippets
                for (const snippet in snippets) {
                    const content = snippets[snippet];
                    // Redraw snippet
                    $(snippet).html(content);
                }

                // Hide show
                bully_show_hide_filter_button();
                // Toggle
                bully_toggle_filters();

                if (showResults) {
                    if($('.js-bully-subject-form-section').length > 0) {
                        $('html, body').animate({
                            scrollTop: $('.js-bully-subject-form-section').offset().top
                        }, 500);
                    }

                    // Disable show result button
                    $('.js-bully-filter-btn').attr('disabled', 'disabled');
                }

                // Init email form validation
                bully_email_form_validation();
                Datepicker.init();
                // same heights
                bully_boxes_same_heights();
            },
            error: function (response) {
            },
            complete: function (response) {
                if (submit.hasClass('btn-primary')) {
                    submit
                        .removeClass('js-loading')
                        .removeAttr('disabled');
                } else {
                    submit.closest('.btn-primary')
                        .removeClass('js-loading')
                        .removeAttr('disabled');
                }

                // Show animation
                $('.js-bully-loading').hide();
            }
        });
    }

    /**
     * Send general/common bully form with AJAX
     *
     * @param {jQuery} form
     */
    function bully_general_form(form) {
        const submit = $('.js-submit');
        const data = new FormData(form[0]);
        const nextStep = get_bully_next_step();
        //
        data.set('next_step', nextStep);
        data.set('is_last_step', bully_is_last_step(get_bully_current_step()));

        // Email form?
        if(form.attr('id') == 'bully-email-form') {
            submit.attr('disabled');
        }

        if(form.valid()) {
            submit
                .addClass('js-loading')
                .attr('disabled', 'disabled');
        }

        $.ajax({
            type: 'POST',
            url: ajaxUrl,
            // dataType:    'json',
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            success: function (response) {
                const data = response.data;

                // Has snippets response?
                if (data.snippets) {
                    const snippets = data.snippets;

                    // Redraw snippets
                    for (const snippet in snippets) {
                        const content = snippets[snippet];
                        // Redraw snippet
                        $(snippet).html(content);
                    }

                    // set step as completed
                    bully_set_step_as_completed(get_bully_current_step());

                    // Change step
                    change_step(nextStep, get_bully_current_step());
                    // Animate progress bar
                    Animation.donationProgressBar();

                    // Init chars
                    update_char_counters();

                    // Init email form validation
                    bully_email_form_validation();
                    Datepicker.init();
                } else if (data.isLastStep) {
                    change_step('step-thankyou', get_bully_current_step());
                }

            },
            error: function (response, textStatus, errorThrown) {
                // Email form?
                if(form.attr('id') == 'bully-email-form') {
                    submit.removeAttr('disabled');
                }
            },
            complete: function (response) {
                if (submit.hasClass('btn-primary')) {
                    submit
                        .removeClass('js-loading')
                        .removeAttr('disabled');
                } else {
                    submit.closest('.btn-primary')
                        .removeClass('js-loading')
                        .removeAttr('disabled');
                }
            }
        });
    }

    /**
     * Send general/common bully form with AJAX
     *
     * @param {jQuery} form
     */
    function bully_add_to_progress_bar() {
        const data = new FormData();

        data.set('action', 'bully_supporter_form');
        data.set('page_id', $('#bully').attr('data-page-id'));
        data.set('component_index', $('#bully').attr('data-component-id'));

        $.ajax({
            type: 'POST',
            url: ajaxUrl,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            success: function (response) {
                const data = response.data;
                const snippets = data.snippets;

                // Redraw snippets
                for (const snippet in snippets) {
                    const content = snippets[snippet];
                    // Redraw snippet
                    $(snippet).html(content);
                }

                // Animate progress bar
                Animation.donationProgressBar();
            },
            error: function (response, textStatus, errorThrown) {
                console.log(textStatus);
            },
            complete: function (response) {
            }
        });
    }

    /**
     * Add point to progress bar by step
     * @param step
     */
    function maybe_add_to_progress_bar(step) {
        if (!bully_is_step_completed(step)) {
            // Send form to add point to progress bar
            bully_add_to_progress_bar();
            // set step as completed
            bully_set_step_as_completed(step);
        }
    }

    /**
     * Copy text to clipboard
     * @param {Element} element
     */
    function copy_text_to_clipboard(element) {
        /* Get the text field */
        var copyText = element;

        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        document.execCommand("copy");
    }

    function bully_boxes_same_heights() {
        // Filter
        _bully_boxes_same_heights($( "#step-filter .bully-box__title" ));
        // Facebook
        _bully_boxes_same_heights($( "#step-facebook .bully-box__title" ));
        // Twitter
        _bully_boxes_same_heights($( "#step-twitter .bully-box__title" ));
    }

    /**
     * @param {jQuery} selector
     */
    function _bully_boxes_same_heights(selector) {
        let maxHeight = 0;

        selector.each(function (index) {
            if (maxHeight < $(this).height()) {
                maxHeight = $(this).height();
            }
        });

        if(maxHeight > 0) {
            selector.height(maxHeight);
        }
    }

    /**
     * @param counter
     */
    function update_char_counters() {
        $('.js-char-counter').each(function () {
            const counter_target = $($(this).attr('data-counter'));
            const chars = $(this).val().length;
            const max_chars = $(this).attr('data-max-chars');

            counter_target.find('.char-counter__current').text(chars);

            if (chars > max_chars) {
                counter_target.addClass('has-more-chars');
            } else {
                counter_target.removeClass('has-more-chars');
            }
        })
    }

    function bully_update_email_message() {
        const firstName = $('.js-bully-first-name-input');
        const lastName = $('.js-bully-last-name-input');
        const fullname = firstName.val() + ' ' + lastName.val();

        // update editor name
        $('.js-bully-email-name').text(fullname);
    }

    /**
     * Convert editor content to textarea
     */
    function convert_editor_to_textarea() {
        const editor = $('.js-textarea-editor');
        const target = $(editor.attr('data-target'));
        let editorClone = editor.clone();

        // Replace div with p
        editorClone.children('div').each(function(e, el) {
            $(el).replaceWith( $('<p />', {text: $(this).text()}) );
        });

        target.html(editorClone.html());
        target.val(editorClone.html());
    }

    function bully_show_hide_filter_button() {
        let allow = true;

        // At least one filter value has to be selected
        if (! $('.js-bully-filter-form-input:checked').length > 0) {
            allow = false;
        }

        // Iterate over all filters to find
        if(allow) {
            $('.js-bully-filter-count').each(function (index) {
                const min = $(this).attr('data-min');
                const max = $(this).attr('data-max');
                const selected = $(this).find('.js-bully-filter-form-input:checked').length;

                // Find how many selected values
                if(min > 0 && selected < min) {
                    allow = false;
                }

                if(max > 0 && selected > max) {
                    allow = false;
                }
            });
        }

        if (allow) {
            $('.js-bully-filter-btn').removeAttr('disabled');
        } else {
            $('.js-bully-filter-btn').attr('disabled', 'disabled');
        }
    }

    function bully_toggle_filters() {
        $('.js-bully-filter-count').each(function (index) {
            const max = $(this).attr('data-max');
            const selected = $(this).find('.js-bully-filter-form-input:checked').length;
            let allow = true;

            // Find how many selected values

            if(max > 0 && selected >= max) {
                allow = false;
            }

            if(allow) {
                $(this).find('.js-bully-filter-form-input:not(:checked)').removeAttr('disabled')
            } else {
                $(this).find('.js-bully-filter-form-input:not(:checked)').attr('disabled', 'disabled')
            }
        });
    }


    // ---------------------------------- Call functions ------------------------------- \\

    // Init bully current section
    bully_show_current_step();
    // Set current step
    bully_set_current_step();
    // Init chars
    update_char_counters();
    // Init email form validation
    bully_email_form_validation();
    // Same heights
    bully_boxes_same_heights();
    bully_show_hide_filter_button();


    // ---------------------------------- Events ------------------------------- \\

    // Show more subjects
    $(document).on('click', '.form-receiver__load-more', function () {
        const list = $(this).closest('.form-receiver');

        list.addClass('is-open');
    });

    // Update email text
    $(document).on('keyup', '.js-bully-first-name-input', function() {
        bully_update_email_message();
    });
    $(document).on('keyup', '.js-bully-last-name-input', function() {
        bully_update_email_message();
    });

    // Chars counter
    $(document).on('keyup', '.js-char-counter', function() {
        update_char_counters();
    })

    // Bully filter form
    $(document).on('change', '.js-bully-filter-form-input', function () {
        bully_filter_form(false);
        // toggle filters
        bully_toggle_filters();
    })

    $(document).on('click', '.js-bully-filter-btn', function (e) {
        e.preventDefault();

        bully_filter_form(true);
    })

    $(document).on('change', '#bully-subject-form .bully-box__input', function (e) {
        e.preventDefault();

        if ($('#bully-subject-form .bully-box__input:checked').length > 0) {
            $('.js-bully-subject-form-btn').removeAttr('disabled');
        } else {
            $('.js-bully-subject-form-btn').attr('disabled', 'disabled');
        }
    })

    /**
     * Send subject form
     */
    $(document).on('click', '.js-bully-subject-form-btn', function (e) {
        e.preventDefault();

        // Send form
        bully_general_form($('#bully-subject-form'));
    });

    /**
     * Send email form
     */
    $(document).on('submit', '#bully-email-form', function (e) {
        e.preventDefault();

        // Nejprve zkontrolujeme, jestli je formulář validní.
        // Pokud ne, jQuery.validate se postará o chyby a my nic neděláme.
        if (!$(this).valid()) {
            return;
        }

        // Pokud je formulář validní, rovnou ho zpracujeme.
        convert_editor_to_textarea();
        bully_general_form($('#bully-email-form'));
    });

    // Next step
    $(document).on('click', '.js-bully-next-step', function (e) {
        e.preventDefault();
        const currentStep = get_bully_current_step();
        const nextStep = get_bully_next_step();

        if (bully_is_last_step(currentStep)) {
            change_step('step-thankyou', get_bully_current_step());
        }

        // Go to next step
        change_step(nextStep, get_bully_current_step());
    })

    // Next step
    $(document).on('click', '.js-bully-previous-step', function (e) {
        e.preventDefault();
        const currentStep = get_bully_current_step();
        const nextStep = get_bully_previous_step();

        // Go to previous step
        change_step(nextStep, get_bully_current_step());
    })

    // Change step
    $(document).on('click', '.js-bully-change-step', function (e) {
        e.preventDefault();
        const step = $(this).attr('data-step');
        const secondStep = $('.bully-navigation__list-item').get(1);

        // We can change step only if second step is visited
        if ($(secondStep).hasClass('is-visited')) {
            change_step(step, get_bully_current_step());
        }
    });

    /**
     * Send tweet
     */
    $(document).on('click', '.js-bully-send-tweet', function (e) {
        e.preventDefault();
        const element = document.querySelector(e.target.getAttribute('data-target'));
        const currentStep = get_bully_current_step();
        const nextStep = get_bully_next_step();

        copy_text_to_clipboard(element);
        window.open('https://x.com/intent/tweet?text=' + encodeURI($(element).val()).replace(/#/g, '%23'), '_blank');

        // Add to progress bar
        maybe_add_to_progress_bar(get_bully_current_step());

        // Redirect user to page
        if (bully_is_last_step(currentStep)) {
            change_step('step-thankyou', get_bully_current_step());
        }

        return false;
    })

    $(document).on('click', '.js-copy-clipboard', function (e) {
        const element = document.querySelector(e.target.getAttribute('data-target'));

        copy_text_to_clipboard(element);
    });

    $(document).on('change', '.js-twitter-box-input', function (e) {
        const textarea = $('#textarea-social-twitter');
        const input_twitter = $(this).attr('data-twitter');
        let text = textarea.text();

        if ($(this).is(':checked')) {
            textarea.text(text + ' ' + input_twitter);
        } else {
            textarea.text(text.replace(input_twitter, ''));
        }

        // Update submit button disable state
        if($('.js-twitter-box-input:checked').length > 0) {
            $('.js-bully-send-tweet');
        } else {
            $('.js-bully-send-tweet');
        }

    });

    // Social intro tabs
    function motivatorIntroTabNextStep(currentStep) {
        // Find next step
        var $tab = $('.tabs-item[data-step="' + currentStep + '"]');
        var $nextStep = null;
        var nextStep = null;

        $('.js-socials-tab').each(function (index, tab) {
            var step = $(tab).attr('data-step');

            if (step == currentStep) {
                $nextStep = $($('.js-socials-tab').get(index + 1));
                nextStep = $nextStep.attr('data-step');
            }
        });

        // Check if next step is thank you
        if(nextStep == 'thank-you') {
            var $thankYouPageTab = $('.tabs-item[data-step="' + nextStep + '"]');
            var redirectUrl = $thankYouPageTab.attr('data-redirect-url');

            if(redirectUrl) {
                window.location.href = redirectUrl;
                return;
            }
        }

        jQuery('.tabs-nav ul li a.active').removeClass('active');
        jQuery('.tabs-item').removeClass('tabs-item--active');

        // Go to next step
        if ($nextStep && $nextStep.length > 0) {
            $nextStep.addClass('tabs-item--active');
            // Nav item
            $('.js-socials-menu-item').each(function (i, item) {
                var $item = $(item);

                if ($item.attr('data-step') == nextStep) {
                    $item.addClass('active');
                }
            })
        }
    }

    $(document).on('click', '.js-socials-next-step', function(e) {
        e.stopPropagation();
        //
        var currentStep = $(this).closest('.js-socials-tab').attr('data-step');
        //
        jQuery('.tabs-nav ul li a.active').removeClass('active');
        motivatorIntroTabNextStep(currentStep);
        // Animate
        jQuery('html, body').animate({
            scrollTop: jQuery('#odesli').offset().top - (jQuery('#odesli').offset().top > 74 ? 74 : 0)
        }, 1000, function () {
        });

        return false;
    });

    // Twitter tweet
    $(document).on('click', '.js-socials-tweet-send', async function (e) {
        // 1. Funkce je nyní 'async', abychom mohli použít 'await'
        e.preventDefault();

        // Tato část zůstává stejná - připraví text a otevře okno pro sdílení
        var value = document.querySelector('[name=twitter_message]').value;
        value = br2nl(value);
        value = value.replace(/(<([^>]+)>)/gi, "");
        document.querySelector('[name=twitter_message]').value = value;
        var input = document.querySelector('[name=twitter_message]');
        input.select();
        input.setSelectionRange(0, 99999);
        document.execCommand('copy');
        motivatorIntroTabNextStep('twitter');
        window.open(
            'https://x.com/intent/tweet?text=' + encodeURI(jQuery('[name=twitter_message]').val()).replace(/#/g, '%23'),
            '_blank'
        );

        // 2. Načteme email z (pravděpodobně) hlavního formuláře na stránce
        const emailInput = document.querySelector('form input[name="email"]');
        let hashedEmail = null; // Výchozí hodnota, kdyby se e-mail nenašel

        // Zkontrolujeme, zda jsme pole s e-mailem našli a zda není prázdné
        if (emailInput && emailInput.value) {
            // 3. Zavoláme naši centrální funkci GA.sha256 a počkáme na výsledek
            hashedEmail = await GA.sha256(emailInput.value);
        }

        // 4. Odešleme upravený objekt do dataLayer
        window.dataLayer = window.dataLayer || [];
        if (!window.dataLayerPushed) {
            dataLayer.push({
                event: 'engagementActivity',
                eventCategory: 'engagement',
                eventAction: 'Twitter',
                gp_user_id: hashedEmail // Vložíme hash (nebo null, pokud e-mail nebyl nalezen)
            });
            window.dataLayerPushed = true;
        }

        return false;
    });

    // Facebook post
    $(document).on('click', '.js-socials-facebook-send', async function (e) {
        // 1. Funkce je 'async'
        e.preventDefault();

        // Původní logika pro přípravu a otevření Facebook okna
        var value = document.querySelector('[name=facebook_message]').value;
        value = value.replace(/(<([^>]+)>)/gi, "");
        document.querySelector('[name=facebook_message]').value = value;
        var input = document.querySelector('[name=facebook_message]');
        input.select();
        input.setSelectionRange(0, 99999);
        document.execCommand('copy');
        motivatorIntroTabNextStep('facebook');
        window.open($(this).attr('data-facebook-url'), '_blank');

        // 2. Načtení a hashování e-mailu (stejné jako u Twitteru)
        const emailInput = document.querySelector('form input[name="email"]');
        let hashedEmail = null;

        if (emailInput && emailInput.value) {
            // 3. Volání centrální funkce
            hashedEmail = await GA.sha256(emailInput.value);
        }

        // 4. Odeslání do dataLayer
        window.dataLayer = window.dataLayer || [];
        if (!window.dataLayerPushed) {
            dataLayer.push({
                event: 'engagementActivity',
                eventCategory: 'engagement',
                eventAction: 'Facebook', // Změna na Facebook
                gp_user_id: hashedEmail
            });
            window.dataLayerPushed = true; 
        }

        return false;
    });

    // Init form messages
    /**
     * @param {jQuery} $message
     * @param {boolean} random
     * @param {boolean} updateName
     */
    function changeSocialFormMessage($message, random = false, updateName = false) {
        var propertyKey = $message.attr('data-script-property');
        var messages = window[propertyKey];
        var length = messages.length;
        var index = parseInt($message.attr('data-index'));
        index = isNaN(index) ? 0 : index;
        var $input = $message.parent().find('input, textarea');

        if(random) {
            index = Math.floor(Math.random() * length);
        }

        // is wp editor
        if($message.attr('data-type') === 'wp_editor') {
            tinymce.activeEditor.setContent(messages[index]);
        } else {
            // Textarea
            $message.html(messages[index]);
            // Update input
            if($input.length > 0) {
                $input.val(messages[index]);
            }
        }

        var newIndex = index + 1;
        $message.attr('data-index', newIndex >= length ? 0 : newIndex);

        // Update content with first and last name
        if(updateName) {
            socialFormFirstName(jQuery('.js-social-form-first-name'));
            socialFormSurname(jQuery('.js-social-form-surname'))
        }
    }

    $(document).on('click', '.refresh-btn', function() {
        var $tab = $(this).closest('.js-socials-tab');
        var $message = $tab.find('.js-socials-message');

        //
        changeSocialFormMessage($message, false, true);
    });

    $(document).on('change', '.js-social-form-first-name', function(e) {
        socialFormFirstName(jQuery(this));
    });

    $(document).on('change', '.js-social-form-surname', function(e) {
        socialFormSurname(jQuery(this));
    });

    function socialFormFirstName($input) {
        //
        jQuery('.name').html($input.val());
        jQuery('[name=message]').val(jQuery('.message-editor').html());
        var content = tinymce.activeEditor.getBody();
        jQuery(content).find('.name').html($input.val());
        tinymce.activeEditor.setContent(jQuery(content).html());
        //
    }

    function socialFormSurname($input) {
        jQuery('.surname').html($input.val());
        jQuery('[name=message]').val(jQuery('.message-editor').html());
        var content = tinymce.activeEditor.getBody();
        jQuery(content).find('.surname').html($input.val());
        tinymce.activeEditor.setContent(jQuery(content).html());
        //
    }

    // Init messages
    setTimeout(function() {
        $('.js-socials-message').each(function(index, item) {
            changeSocialFormMessage($(item), true);
        });
    }, 500);

    // Check for success parameter and show thank you tab
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('socials_success') === '1') {
        // Remove active class from all tabs
        $('.tabs-nav ul li a.active').removeClass('active');
        $('.tabs-item').removeClass('tabs-item--active');

        // Show thank you tab
        var $thankYouTab = $('.tabs-item[data-step="thank-you"]');
        if ($thankYouTab.length > 0) {
            $thankYouTab.addClass('tabs-item--active');

            // Scroll to the form section
            if ($('#odesli').length > 0) {
                $('html, body').animate({
                    scrollTop: $('#odesli').offset().top - ($('#odesli').offset().top > 74 ? 74 : 0)
                }, 1000);
            }
        }
    }

    /**
     * FB btn set as completed/active
     */
    $(document).on('click', '.js-bully-fb-btn', function (e) {
        $(this).addClass('is-active');
        maybe_add_to_progress_bar(get_bully_current_step());
    });

});
